<template>
  <app-modal title="ui.settings" v-model="show">
    <div class="text-center mb-4">
      <app-edit-avatar :customer="customer" />
    </div>

    <b-form @submit.prevent="onSubmit">
      <app-form-input
        v-model="form.name"
        placeholder="ui.group_name"
        :error="errors.name"
      />
      <b-button
        v-if="!!myFriendListId"
        type="submit"
        :disabled="submitted"
        variant="primary"
        block
        >{{ "ui.save" | trans }}</b-button
      >
    </b-form>
  </app-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppModal from "@/components/modal/Modal";
import AppFormInput from "@/components/form/FormInput";
import AppEditAvatar from "@/views/Account/MyAccount/Settings/EditAvatar";

export default {
  name: "SettingsView",
  components: { AppEditAvatar, AppFormInput, AppModal },
  created() {
    this.getMyFriendList();
  },
  computed: {
    ...mapGetters("friendLists", ["myFriendList"]),
    ...mapGetters("customers", ["customer"]),
    show: {
      get() {
        return this.showValue;
      },
      set(value) {
        this.showValue = value;
        this.$router.go(-1);
      },
    },
    myFriendListId() {
      if (!this.myFriendList) {
        return;
      }

      return this.myFriendList.code;
    },
  },
  methods: {
    ...mapActions("friendLists", ["getMyFriendList", "patchFriendList"]),
    async onSubmit() {
      this.submitted = true;
      try {
        await this.patchFriendList({
          id: this.myFriendListId,
          data: this.form,
        });
        this.$router.go(-1);
      } catch (e) {
        if (!e.response) {
          return;
        }

        if (e.response.status === 422) {
          Object.keys(e.response.data).forEach(name => {
            this.errors[name] = e.response.data[name].shift();
          });
        }
      } finally {
        this.submitted = false;
      }
    },
  },
  watch: {
    myFriendList: {
      handler(value) {
        if (!value) {
          return;
        }

        this.form.name = value.name;
      },
      immediate: true,
    },
  },
  data() {
    return {
      showValue: true,
      submitted: false,
      errors: {
        name: null,
      },
      form: {
        name: "",
      },
    };
  },
};
</script>
